import { AppProvider } from './context/AppContext';
import AppRouter from './components/AppRouter';
import UpdateNotification from './components/UpdateNotification';

function App() {

  return (
    <AppProvider>
      <UpdateNotification />
      <AppRouter />
    </AppProvider>
  );
}

export default App;
